/** @jsxRuntime classic */
/** @jsx jsx */
import { memo, useRef, forwardRef, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { jsx, css } from '@emotion/core';
import theme from "../../theme/settings";
import Ripple from "../button/ripple-effect";
const ListItem = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  children,
  className,
  style,
  onClick,
  button,
  inset,
  refs,
  ...props
}, ref) => {
  if (!ref) {
    ref = useRef(null);
  }
  const ListItemRoot = css`
            display: flex;
            position: relative;
            flex: 1 1 auto;
            flex-direction: row;
            align-items: center;
            width: 100%;
            max-width: 360px;
            height: auto;
            min-height: 32px;
            padding: 0 16px;
            color: ${theme.colors.system.active};
            overflow: hidden;
            background-color: inherit;
            box-sizing: border-box;
            &.click-able {
                cursor: pointer;
                user-select: none;
                &:hover {
                    background-color: ${theme.colors.fill.hover};
                }
            }
            &.DGN-Active {
                background-color: ${theme.colors.fill.hover};
            }
            &.inset {
                padding-left: 56px;
            }
        `;
  const handleClick = e => {
    const {
      currentTarget,
      target
    } = e;
    const actionNode = currentTarget.querySelector('.DGN-UI-List-Item-Action');
    if (!actionNode || !actionNode.contains(target)) {
      onClick(e);
    }
  };
  useEffect(() => {
    if (refs) refs(ref);
  }, []);
  useEffect(() => {
    if (inset) {
      ref.current.classList.add('inset');
    }
    return () => {
      if (inset && ref.current) {
        ref.current.classList.remove('inset');
      }
    };
  }, [inset]);
  const ListItemView = useMemo(() => jsx("div", {
    css: ListItemRoot,
    className: 'DGN-UI-List-Item ' + (onClick ? 'click-able ' : '') + className,
    ref: ref,
    onClick: onClick ? handleClick : null,
    style: style,
    ...props
  }, children, button && jsx(Ripple, {
    color: '#8F9BB3'
  })), [children, button, style]);
  return ListItemView;
}));
ListItem.defaultProps = {
  className: ''
};
ListItem.propTypes = {
  /** has the same effect as a button if true */
  button: PropTypes.bool,
  /** classes name for list item */
  className: PropTypes.string,
  /** the function to get ref of ListItem */
  refs: PropTypes.func,
  /** the function for click event */
  onClick: PropTypes.func,
  /** style inline of ListItem */
  style: PropTypes.object,
  /** includes ListItemIcon, ListItemText, ListItemAction */
  children: PropTypes.node
};
export default ListItem;